module.exports = __webpack_public_path__ + "img/banner_01.22d4b957.jpg";